import { DashboardCommentsComponent } from './components/dashboard-comments/dashboard-comments.component';
import { DashboardScorecardComponent } from './components/dashboard-scorecard/dashboard-scorecard.component';


export const rightPanelNavs: Array<any> = [
  {
    title: 'Comments',
    name: 'comments',
    active: false,
    component: DashboardCommentsComponent,
  },
  {
    title: 'Scorecard',
    name: 'scorecard',
    active: false,
    component: DashboardScorecardComponent,
  },
];
